export const getBarMenuCategoriesPath = (
  barId: string,
  tableId: string
): string => `/bar-menu/${barId}/${tableId}/categories`;

export const getPublicBarMenuPath = (barId: string): string =>
  `/barmenu/${barId}`;
